import { Typography } from '@euler/app/components/typography';
import { FontFamily } from '@euler/components/typography';
import { FuseResultMatch } from 'fuse.js';
import { memo } from 'react';
import { StyleProp, Text, TextStyle } from 'react-native';

export const LabelWithHighlights = memo(
  ({
    title,
    matches,
    highlightStyle,
    ...props
  }: {
    title: string;
    matches?: ReadonlyArray<FuseResultMatch>;
    style?: StyleProp<TextStyle>;
    highlightStyle?: StyleProp<TextStyle>;
  } & Typography.TextBaseProps) => {
    if (!matches || matches.length === 0) {
      return <Typography.Label {...props}>{title}</Typography.Label>;
    }

    const parts: (string | React.ReactElement)[] = [];
    let lastIndex = 0;

    matches.forEach(match => {
      const { indices } = match;
      indices.forEach(([start, end]) => {
        if (start > lastIndex) {
          parts.push(title.substring(lastIndex, start));
        }
        parts.push(
          <Text
            key={`${start}-${end}`}
            style={[
              { color: 'red', fontFamily: FontFamily.NotoSans.Regular },
              highlightStyle,
            ]}
          >
            {title.substring(start, end + 1)}
          </Text>,
        );
        lastIndex = end + 1;
      });
    });

    if (lastIndex < title.length) {
      parts.push(title.substring(lastIndex));
    }

    return <Typography.Label {...props}>{parts}</Typography.Label>;
  },
);
